enum EmployeeAction {
  FETCH_ALL = 'employees/fetchAll',
  SELECT_EMPLOYEE_FILTER = 'employees/setEmployee',
  UPDATE_EMPLOYEE = 'employees/updateEmployee',
  ADD_EMPLOYEE = 'employees/addEmployee',
  CLEAN_SELECTED_EMPLOYEE = 'employees/cleanSelectedEmployee'
}

export default EmployeeAction;
